export const CSGetEntity = `
query GetEntity($id: ID!) {
  getEntity(id: $id) {
    id
    type
    taxNumber
    companyNumber
    billerCode
    name
    legalName
    businessNames
    searchName
    address {
      addressId
      contactName
      contactNumber
      fullAddress
      address1
      address2
      city
      country
      countryCode
      state
      stateCode
      postalCode
      invalid
    }
    logo {
      alt
      identityId
      key
      level
      type
    }
    brandColour
    website
    entityUsers {
      items {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        referredBy
        invitedEntityId
        firmEntityId
        managerId
        partnerId
        firstName
        lastName
        role
        jobTags
        paymentsEnabled
        clientGroupCode
        clientCode
        taskSendSMS
        ocrEmail
        termsInvoiceAccepted
        termsOcrAccepted
        entitySearchName
        searchName
        taxNumber
        companyNumber
        createdBy
        createdAt
        updatedAt
        archivedAt
        status
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
      }
      nextToken
    }
    gstRegistered
    gstReportingPeriod
    providerEntityId
    providerCompanyId
    providerBillUserCompanyId
    providerBankAccountId
    providerDigitalWalletId
    providerBpayCrn
    contact {
      firstName
      lastName
      email
      phone
      role
    }
    paymentMethods {
      items {
        id
        paymentMethodType
        type
        fullName
        number
        expMonth
        expYear
        accountName
        bankName
        accountNumber
        routingNumber
        holderType
        accountType
        status
        accountDirection
        expiresAt
        createdAt
        updatedAt
        consentId
        consentStatus
        card
        googlepay
        applepay
      }
      nextToken
    }
    paymentMethodId
    paymentUserId
    disbursementMethodId
    receivingAccounts {
      items {
        id
        paymentMethodType
        type
        fullName
        number
        expMonth
        expYear
        accountName
        bankName
        accountNumber
        routingNumber
        holderType
        accountType
        status
        accountDirection
        expiresAt
        createdAt
        updatedAt
        consentId
        consentStatus
        card
        googlepay
        applepay
      }
      nextToken
    }
    ubosCreated
    numUbosCreated
    subCategory
    clientsStatus
    ocrEmail
    termsInvoiceAccepted
    termsOcrAccepted
    owner
    referredBy
    connectedAccount
    accountStatus
    customerId
    xeroSyncStatus
    xeroLastContactSyncAt
    xeroContactSyncStatus
    xeroInvoiceSyncStatus
    xeroLastInvoiceSyncAt
    xeroTenantId
    absorbFees
    subscriptionTier
    invitationStatus
    clientsOnboardingStatus
    createdBy
    isFirm
    createdByEntityId
    createdAt
    updatedAt
  }
}
`;

export const CSIsLoggedIn = `
  query IsUserLoggedIn {
    isLoggedIn @client
  }
`;
export const CSGetSub = `
  query GetSub {
    sub @client
  }
`;

export const CSGetSelectedEntityId = `
  query GetSelectedEntityId {
    selectedEntityId @client
  }
`;

export const CSGetRecentClients = `
  query GetRecentClients {
    recentClients @client
  }
`;

export const CSGetUserType = `
  query GetUserType {
    userType @client
  }
`;

export const CSGetEntityUsersByFirmId = /* GraphQL */ `
  query EntityUsersByFirmId(
    $firmId: ID!
    $searchName: String
    $clientGroupCode: String
    $sortDirection: ModelSortDirection
    $from: Int
    $limit: Int
    $roles: [EntityUserRole]
    $nextToken: String
    $includeArchived: Boolean
    $archivedOnly: Boolean
  ) {
    entityUsersByFirmId(
      firmId: $firmId
      searchName: $searchName
      clientGroupCode: $clientGroupCode
      sortDirection: $sortDirection
      from: $from
      limit: $limit
      roles: $roles
      nextToken: $nextToken
      includeArchived: $includeArchived
      archivedOnly: $archivedOnly
    ) {
      items {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        clientGroupCode
        clientCode
        firstName
        lastName
        ocrEmail
        role
        jobTags
        entitySearchName
        archivedAt
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
          contact {
            firstName
            lastName
            email
            phone
            role
          }
        }
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
        partnerId
        managerId
        searchName
        taxNumber
        createdBy
        createdAt
        updatedAt
        status
      }
      total
    }
  }
`;

export const CSGetentityUsersByEntityId = /* GraphQL */ `
  query EntityUsersByEntityId(
    $entityId: ID!
    $searchName: String
    $sortDirection: ModelSortDirection
    $from: Int
    $limit: Int
    $nextToken: String
  ) {
    entityUsersByEntityId(
      entityId: $entityId
      searchName: $searchName
      sortDirection: $sortDirection
      from: $from
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        referredBy
        invitedEntityId
        firmEntityId
        ownerCode
        clientGroupCode
        clientCode
        firstName
        lastName
        ocrEmail
        role
        jobTags
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        termsFirmPayTaxAccepted
        entitySearchName
        searchName
        taxNumber
        taskSendSMS
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        entity {
          id
          contact {
            firstName
            lastName
            email
            phone
            role
          }
        }
        firm {
          id
          name
          legalName
          searchName
        }
      }
      total
    }
  }
`;

export const CSGetEntityUsersOnlyByFirmId = /* GraphQL */ `
  query EntityUsersByFirmId(
    $firmId: ID!
    $searchName: String
    $clientGroupCode: String
    $sortDirection: ModelSortDirection
    $from: Int
    $limit: Int
    $roles: [EntityUserRole]
    $nextToken: String
    $includeArchived: Boolean
    $archivedOnly: Boolean
  ) {
    entityUsersByFirmId(
      firmId: $firmId
      searchName: $searchName
      clientGroupCode: $clientGroupCode
      sortDirection: $sortDirection
      from: $from
      limit: $limit
      roles: $roles
      nextToken: $nextToken
      includeArchived: $includeArchived
      archivedOnly: $archivedOnly
    ) {
      items {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        clientGroupCode
        clientCode
        firstName
        lastName
        ocrEmail
        role
        jobTags
        entitySearchName
        archivedAt
        searchName
        taxNumber
        createdBy
        createdAt
        updatedAt
        partnerId
        managerId
        status
        taxPaymentReferences {
          itr {
            referenceNumber
            updatedAt
          }
          other {
            referenceNumber
            updatedAt
          }
        }
        entity {
          id
          contact {
            firstName
            lastName
            email
            phone
            role
          }
        }
      }
      total
    }
  }
`;

export const GET_SIGNERS = `
  query GetSigner(
  $entityId: ID!
  $sortDirectionContact: ModelSortDirection
  $sortDirectionEntityUser: ModelSortDirection
  $searchName: String
  $from: Int
  $nextToken: String
) {
  contactsByEntity(
    entityId: $entityId
    searchName: $searchName
    sortDirection: $sortDirectionContact
    from: $from
  ) {
    items {
      id
      entityId
      firstName
      lastName
      email
      phone
      name
      searchName
      status
      createdAt
      updatedAt
      contactType
      owner
    }
    total
  }
  entityUsersByEntityId(
    entityId: $entityId
    sortDirection: $sortDirectionEntityUser
    searchName: $searchName
    limit: 10
    nextToken: $nextToken
  ) {
    items {
      id
      entityId
      userId
      invitedEmail
      referredBy
      invitedEntityId
      firmEntityId
      firstName
      lastName
      role
      paymentsEnabled
      entitySearchName
    }
    total
  }
}
`;

export const GET_CONTACTS_AND_VERIFIED_ENTITY = /* GraphQL */ `
  query GetContactsAndVerifiedEntity(
    $entityId: ID!
    $type: AutocompleteType!
    $searchName: String!
    $sortDirectionContact: ModelSortDirection
    $sortDirectionAutoComplete: ModelSortDirection
    $filterAutoComplete: ModelEntityFilterInput
    $limitAutoComplete: Int
    $nextToken: String
  ) {
    contactsByEntity(
      entityId: $entityId
      searchName: $searchName
      sortDirection: $sortDirectionContact
    ) {
      items {
        id
        entityId
        firstName
        lastName
        email
        phone
        name
        searchName
        status
        createdAt
        updatedAt
        contactType
        owner
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
      }
      total
    }
    autocompleteResultsByType(
      type: $type
      searchName: $searchName
      sortDirection: $sortDirectionAutoComplete
      filter: $filterAutoComplete
      limit: $limitAutoComplete
      nextToken: $nextToken
    ) {
      items {
        id
        value
        label
        info
        type
        searchName
        metadata {
          billerCode
          subCategory
          payoutMethod
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const GET_CLIENT_CONTACTS = /* GraphQL */ `
  query GetClientContacts(
    $entityId: ID!
    $searchName: String!
    $sortDirectionContact: ModelSortDirection
  ) {
    entityUsersByFirmId(
      firmId: $entityId
      searchName: $searchName
      roles: [ACCOUNTANT]
      limit: 5
    ) {
      items {
        id
        entityId
        userId
        firmId
        email
        invitedEmail
        referredBy
        invitedEntityId
        firmEntityId
        clientCode
        firstName
        lastName
        role
        paymentsEnabled
        termsInvoiceAccepted
        termsOcrAccepted
        entitySearchName
        taskSendSMS
        entity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          logo {
            alt
            identityId
            key
            level
            type
            __typename
          }
          brandColour
          website
          gstRegistered
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
            __typename
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
          __typename
        }
        searchName
        taxNumber
        companyNumber
        createdBy
        createdAt
        updatedAt
        status
        __typename
      }
      total
      __typename
    }
    contactsByEntity(
      entityId: $entityId
      searchName: $searchName
      sortDirection: $sortDirectionContact
    ) {
      items {
        id
        entityId
        firstName
        lastName
        email
        phone
        name
        searchName
        status
        createdAt
        updatedAt
        contactType
        owner
        bank {
          id
          accountName
          bankName
          accountNumber
          routingNumber
          holderType
          accountType
          country
        }
        bpay {
          billerCode
          referenceNumber
        }
      }
      total
    }
  }
`;

export const CSGetTemplatesByEntity = /* GraphQL */ `
  query TemplatesByEntity(
    $entityId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    templatesByEntity(
      entityId: $entityId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        entityId
        title
        searchName
        templateJson
        templateHtml
        includeLetterhead
        type
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;

export const GET_AUTO_COMPLETE = `
  query GetAutoComplete(
    $id: ID!
  ){
    getAutoComplete(id: $id){
      contact {
        id
        firstName
        lastName
        name
        searchName
        contactType
        entityId
        email
        address {
          address1
        }
        bank {
          accountNumber
          routingNumber
        }
        bpay {
          billerCode
          referenceNumber
        }
        taxNumber
      }
      entity {
        id
        name
        legalName
        searchName
        logo {
          alt
          identityId
          type
        }
        paymentMethods {
          items {
            id
            routingNumber
            accountNumber
          }
        }
        taxNumber
        brandColour
        contact {
          email
          phone
          firstName
          lastName
        }
        address {
          address1
        }
        disbursementMethodId
        paymentMethodId
        gstRegistered
        accountStatus
        owner
      }
    }
  }
`;

export const CSGetDocumentAnalysisByEntityStatus = /* GraphQL */ `
  query DocumentAnalysisByEntityStatus(
    $entityId: ID!
    $status: DocumentAnalysisStatus
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    documentAnalysisByEntityStatus(
      entityId: $entityId
      status: $status
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        entityId
        fileKey
        documents {
          identityId
          key
          level
          type
        }
        status
        expenseStatus
        queryStatus
        matchedBiller {
          billerCode
          billerCategory
          shortName
          longName
          type
          industryCode
          industryCodeDescription
          createdAt
          updatedAt
        }
        matchedContactId
        matchedContact {
          id
          entityId
          xeroTenantId
          entityType
          firstName
          lastName
          email
          mobile
          phone
          taxNumber
          companyNumber
          name
          legalName
          searchName
          status
          website
          createdAt
          updatedAt
          contactType
          bank {
            id
            accountName
            bankName
            accountNumber
            routingNumber
            holderType
            accountType
            country
          }
          bpay {
            billerCode
            referenceNumber
          }
          invalidFields
          bulkUploadFileKey
          owner
          createdBy
          beneficiaryBankId
          beneficiaryBpayId
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          postal {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          payoutErrors
        }
        matchedEntityId
        matchedEntity {
          id
          type
          taxNumber
          companyNumber
          billerCode
          name
          legalName
          businessNames
          searchName
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
          logo {
            alt
            identityId
            key
            level
            type
          }
          brandColour
          website
          gstRegistered
          gstReportingPeriod
          providerEntityId
          providerCompanyId
          providerBillUserCompanyId
          providerBankAccountId
          providerDigitalWalletId
          providerBpayCrn
          contact {
            firstName
            lastName
            email
            phone
            role
          }
          paymentMethods {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          paymentMethodId
          paymentUserId
          disbursementMethodId
          receivingAccounts {
            items {
              id
              paymentMethodType
              type
              fullName
              number
              expMonth
              expYear
              accountName
              bankName
              accountNumber
              routingNumber
              holderType
              accountType
              status
              accountDirection
              expiresAt
              createdAt
              updatedAt
              consentId
              consentStatus
              card
              googlepay
              applepay
            }
            nextToken
          }
          ubosCreated
          numUbosCreated
          subCategory
          clientsStatus
          ocrEmail
          termsInvoiceAccepted
          termsOcrAccepted
          owner
          referredBy
          connectedAccount
          accountStatus
          customerId
          xeroSyncStatus
          xeroLastContactSyncAt
          xeroContactSyncStatus
          xeroInvoiceSyncStatus
          xeroLastInvoiceSyncAt
          xeroTenantId
          absorbFees
          subscriptionTier
          invitationStatus
          clientsOnboardingStatus
          createdBy
          createdByEntityId
          isFirm
          createdAt
          updatedAt
        }
        newContact {
          firstName
          lastName
          email
          mobile
          phone
          name
          taxNumber
          address {
            addressId
            contactName
            contactNumber
            fullAddress
            address1
            address2
            city
            country
            countryCode
            state
            stateCode
            postalCode
            invalid
          }
        }
        task {
          reference
          dueAt
          issuedAt
          gstInclusive
          notes
          amount
          gstAmount
          taxAmount
          lineItems {
            description
            quantity
            unitPrice
            price
            productCode
            taxType
          }
          numberOfPayments
          paymentFrequency
          shippingAmount
          partnerId
          managerId
          documentType
          category
          period
          year
        }
        bpay {
          billerCode
          referenceNumber
        }
        bank {
          accountNumber
          routingNumber
        }
        category
        source
        isCorrect
        fromEmail
        textContent
        createdBy
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
